import EventEmitter from 'events';

export const EVENTS = {
    fetchSuccess: 'fetchSuccess',
    fetchError: 'fetchError',
};

export const eventBus = new EventEmitter();
